import {useCallback, useEffect, useState} from 'react';

export const useExternalScript = (url: string) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);

    const handleLoaded = useCallback(() => {
        setLoading(false);
        setLoaded(true);
    }, []);

    const handleError = useCallback(() => {
        setLoading(false);
        setError(true);
    }, []);

    useEffect(() => {
        if (!url) {
            setError(true);
        }
        let script = document.querySelector(`script[src="${url}"]`);

        if (!script) {
            script = document.createElement('script');
            (script as any).type = 'application/javascript';
            (script as any).src = url;
            (script as any).async = true;
            document.body.appendChild(script);
            script.addEventListener('load', handleLoaded);
            script.addEventListener('error', handleError);

            return () => {
                script.removeEventListener('load', handleLoaded);
                script.removeEventListener('error', handleError);
            };
        } else {
            handleLoaded();
        }
    }, [url, handleError, handleLoaded]);

    return {loading, loaded, error};
};